import { Link, useLocation } from 'react-router-dom';
import { useEffect } from 'react';
import HashLink, { scrollToHash } from './HashLink';

function Nav() {
  const location = useLocation();

  // After navigating to a hash route (e.g. /#contact), scroll to it
  useEffect(() => {
    if (location.hash) {
      // Small delay to allow page render
      const timer = setTimeout(() => scrollToHash(location.hash), 80);
      return () => clearTimeout(timer);
    }
  }, [location]);

  return (
    <nav className="site-nav">
      <Link to="/" className="nav-logo">
        <img
          src={`${process.env.PUBLIC_URL}/nation-logo.svg`}
          alt="Nation Wholesale LLC"
          className="nav-logo-img"
        />
        <span className="nav-logo-text">
          NATION <span>WHOLESALE LLC</span>
        </span>
      </Link>
      <ul className="nav-links">
        <li>
          <HashLink hash="#services">Services</HashLink>
        </li>
        <li>
          <Link to="/products">Products</Link>
        </li>
        <li>
          <HashLink hash="#how">How It Works</HashLink>
        </li>
        <li>
          <HashLink hash="#faq">FAQ</HashLink>
        </li>
        <li>
          <HashLink hash="#about">About</HashLink>
        </li>
        <li>
          <HashLink hash="#contact">Contact</HashLink>
        </li>
        <li>
          <Link to="/wholesale" className="nav-cta">
            Apply for Wholesale
          </Link>
        </li>
      </ul>
    </nav>
  );
}

export default Nav;
